import { format, isValid, parse } from 'date-fns';

// A birthday is a calendar day with no time or zone, and the API speaks `YYYY-MM-DD` both ways.
// Convert through LOCAL date parts only: `new Date(s)` loses a day west of UTC, `toISOString()` one east.
export const parseBirthday = (s?: string | null): Date | null => {
  if (!s) return null;
  const d = parse(s.slice(0, 10), 'yyyy-MM-dd', new Date());
  return isValid(d) ? d : null;
};

export const formatBirthday = (d: Date): string => format(d, 'yyyy-MM-dd');

// For display: the stored `yyyy-MM-dd` shown as `dd/MM/yyyy`.
export const displayBirthday = (s?: string | null): string => {
  const d = parseBirthday(s);
  return d ? format(d, 'dd/MM/yyyy') : '';
};
